import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from '../app.component';

// PrimeNG Components for demos
import { PrimeNGModule } from 'src/app/shared/primeng.module';

import { MarkAsteriskDirectiveModule } from '../directives/mark-asterisk.directive';

import { ServiciosComponent } from './servicios.component';
import { ServiciosRoutingModule } from './servicios-routing.module';
import { FAZILService } from '../core/services';
import { UIService } from '../core/services/ui.service';
import { ServiciosService } from './servicios.service';
import { ProductoComponent } from './producto.component';
import { ProductoBuscadorComponent } from './producto-buscador.component';



@NgModule({
  declarations: [
    ProductoComponent,
    ProductoBuscadorComponent,
    ServiciosComponent
  ],
  bootstrap: [AppComponent],
    imports: [
        CommonModule,
        PrimeNGModule,
        MarkAsteriskDirectiveModule,
        FormsModule,
        ReactiveFormsModule,
        ServiciosRoutingModule
    ],
    providers: [
        FAZILService,
        UIService,
        ServiciosService,
    ],
    exports: [
        ProductoComponent,
        ProductoBuscadorComponent
      ],
})
export class ServiciosModule { }
